import React from 'react';
import LegalPage from './LegalPage';

const RefundPolicyPage = () => {
  return (
    <LegalPage title="Refund & Return Policy" slug="refund-policy" lastUpdated="January 2026">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">1. Return Window</h2>
        <p className="text-zinc-700 leading-relaxed">
          We offer a 7-day return policy. You can return any product within 7 days of delivery if you're not satisfied with your purchase.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">2. Return Eligibility</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">Products can be returned if:</p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>Product is unused and in original condition</li>
          <li>Original packaging is intact with all tags attached</li>
          <li>All accessories and manuals are included</li>
          <li>Product was not damaged by misuse</li>
          <li>Return request is made within 7 days of delivery</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">3. Non-Returnable Items</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">The following items cannot be returned:</p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>Personal care and hygiene products</li>
          <li>Items marked as "non-returnable" on product page</li>
          <li>Products damaged due to misuse or mishandling</li>
          <li>Items without original packaging or tags</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">4. How to Initiate a Return</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">To return a product:</p>
        <ol className="list-decimal pl-6 text-zinc-700 space-y-2">
          <li>Contact our customer support with your order ID</li>
          <li>Provide reason for return and product photos (if applicable)</li>
          <li>Our team will verify eligibility and approve the return</li>
          <li>We will arrange a free pickup from your address</li>
          <li>Pack the product securely with all accessories</li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">5. Refund Processing</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">
          Once we receive and inspect the returned product:
        </p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>Refund will be initiated within 2-3 business days</li>
          <li>Amount will be credited to your original payment method</li>
          <li>Bank processing may take 5-7 additional business days</li>
          <li>You will receive email confirmation of refund</li>
          <li>For COD orders, refund will be via bank transfer</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">6. Replacement Policy</h2>
        <p className="text-zinc-700 leading-relaxed">
          If you receive a defective or wrong product, we will arrange a free replacement. Contact us within 48 hours of delivery with photos of the issue.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">7. Return Shipping</h2>
        <p className="text-zinc-700 leading-relaxed">
          We provide free return pickup for all eligible returns. You do not need to pay for return shipping.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">8. Partial Refunds</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">
          Partial refunds may be issued if:
        </p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>Product shows signs of use beyond inspection</li>
          <li>Packaging is significantly damaged</li>
          <li>Accessories or components are missing</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">9. Contact for Returns</h2>
        <p className="text-zinc-700 leading-relaxed">
          For return and refund queries:<br />
          Email: returns@indicraft.in<br />
          Phone: +91 123-456-7890<br />
          Hours: Monday-Saturday, 9 AM - 7 PM IST
        </p>
      </section>
    </LegalPage>
  );
};

export default RefundPolicyPage;
